import React, { useState } from 'react';

const PlaybackLine = ({audioRef,playBack,width,dimensions,height}) => {
	const [ reload, setreload ] = useState(false);

	function lineClicked(e) {
		setreload(true);
		// console.log(e);
		// console.log(e.clientX);
		// console.log(e.target.clientWidth);
		// console.log(e.target.offsetLeft);
		const offsetLeft = (dimensions.width-e.target.clientWidth)/2
		const percentage = (e.clientX-offsetLeft)/e.target.clientWidth;
		// console.log(percentage);
		// console.log(Math.round(audioRef.current.duration*percentage));
		audioRef.current.currentTime = Math.round(audioRef.current.duration*percentage);
		setTimeout(()=>{
			setreload(false);
		}, 80);
	}
	return(
		<div style={{width:width,height:height}} className='pointer' onClick={lineClicked}>
			{/*{audioRef.current !== undefined && reload === false*/}
			{audioRef.current !== undefined && !isNaN(audioRef.current.duration) && reload === false
				? <div className='flexCenter' style={{pointerEvents:'none',}}>
					<div style={{width:`${playBack/audioRef.current.duration*width}%`,height:height,background:'rgb(240,70,120)',borderLeft:'1px solid rgb(240,70,120)'}} className=''></div>
					<div style={{width:`${width-(playBack/audioRef.current.duration*width)}%`,height:height,background:'rgb(40,40,40)'}} className=''></div>
				</div>
				: <div style={{width:width-1,height:height,background:'rgb(40,40,40)',borderLeft:'1px solid rgb(240,70,120)'}}></div>
			}
		</div>
	)
}

export default PlaybackLine;